import { Link } from '@remix-run/react';
import { NetWorthListItemCategory, NetWorthListItemRouteSection } from '../netWorthItem.types';
import { ListItem } from '../../List';

export interface NetWorthListItem {
  heading: string;
  categories: NetWorthListItemCategory[];
  routeSection: NetWorthListItemRouteSection;
  categoryDisplayFunction: (v: NetWorthListItemCategory) => string;
}

export interface NetWorthListProps {
  items: NetWorthListItem[];
}

export const NetWorthList = ({ items }: NetWorthListProps): JSX.Element => {
  const linkTo = (routeSection: NetWorthListItemRouteSection, category: NetWorthListItemCategory) => {
    let subRoute = category;
    if (category === 'Note Receivable') {
      subRoute = 'note-receivable';
    } else if (category === 'Personal Property Item') {
      subRoute = 'personal-property-item';
    }
    if (routeSection == NetWorthListItemRouteSection.Business) {
      return `${routeSection}`;
    }
    return `${routeSection}/${subRoute}`;
  };

  return (
    <>
      {items.map((item, index) => {
        return (
          <div className="mt-8" key={index}>
            {item.heading && <h1 className="mb-3 text-[16px] font-bold text-darkMode-gray-medium">{item.heading}</h1>}
            <ul className="pl-2 md:pl-4">
              {item.categories.map((category) => (
                <Link tabIndex={1} key={category} to={linkTo(item.routeSection, category)} className="contents">
                  <ListItem
                    withChevron
                    className="!bg-transparent flex cursor-pointer justify-between py-2 !h-12 items-center text-white"
                  >
                    {item.categoryDisplayFunction(category)}
                  </ListItem>
                </Link>
              ))}
            </ul>
          </div>
        );
      })}
    </>
  );
};
